/**
 * Пункт меню «За …» (UIUX views/view-switcher, «Grouping filters»; прототип v4 facetItems): групування за полем-вибором — один пункт, що
 * відкриває таблицю з вкладками за значеннями поля (лише значення із записами, кожне з лічильником). Чисті функції.
 */
import type { IRecordTypeDefinition, IStatBucket } from '@platform/core/types';
import type { IMenuEntry } from './IMenuEntry';

const FACET = 'facet:';

/** Поле групування пункту «За …» за ключем пункту меню (`facet:<поле>`); інший пункт — undefined. */
export function facetFieldOf(itemKey: string | null | undefined): string | undefined {
  return itemKey?.startsWith(FACET) ? itemKey.slice(FACET.length) : undefined;
}

/**
 * Пункт «За …» для поля `field` з підписом групи `title`: подання «Етапи» за цим полем, лічильник — записи зі значенням поля (сума відер
 * фасета без порожнього). null — поля немає, воно приховане визначенням чи без варіантів, або (з лічильниками) жоден запис не має значення,
 * як у прототипі.
 */
export function facetEntryOf(rt: IRecordTypeDefinition, field: string, buckets: readonly IStatBucket[] | undefined, title: string): IMenuEntry | null {
  const def = rt.fields.find((f) => f.key === field);
  if (!def?.options?.length || def.hidden) return null;
  const count = buckets ? buckets.reduce((sum, b) => (b.value ? sum + b.count : sum), 0) : undefined;
  if (count === 0) return null;
  return { key: `${FACET}${field}`, label: title, group: title, view: 'stages', count };
}
